import { useMutation } from 'react-query';
import Customers from '../../services/Customers';

export const useUpdatePatientIgnoredStatus = () =>
  useMutation(({ customerId }: { customerId: string }) => Customers.updateIgnoredPatient(customerId));
